document.addEventListener('DOMContentLoaded', function () {
  // Function to show or hide the div
  function showOrHideDiv() {
    var element = document.querySelector(".get_event_updated");
    const appenddiv = document.getElementById("appenddiv");
    if (appenddiv !== null) {
      if (element && element.getAttribute("data-selected-value") === "Yes") {
        appenddiv.style.opacity = 1;
      } else {
        appenddiv.style.opacity = 0;
      }
    }
  }
  // Function to observe changes in the 'data-selected-value' attribute
  function observeDataSelectedValueChanges() {
    var target = document.querySelector(".get_event_updated");
    if (target) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === "attributes" && mutation.attributeName === "data-selected-value") {
            showOrHideDiv();
          }
        });
      });
      // Start observing the target node for attribute changes
      observer.observe(target, { attributes: true });
    }
  }

  // Call the function to observe changes
  observeDataSelectedValueChanges();
  // Call the function initially to set the initial state
  showOrHideDiv();

  // Select all elements with the class .variant-picker__option
  var variantOptions = document.querySelectorAll('.variant-picker__option');
  // Add a click event listener to each .variant-picker__option element
  variantOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      // Get the data-value attribute of the clicked .variant-picker__option
      var selectedValue = option.getAttribute('data-value');
      // Call the function with the selectedValue
      addCustomActiveToMatchingElements(selectedValue);
    });
  });
  // Function to add custom-active class to matching elements
  function addCustomActiveToMatchingElements(selectedValue) {
    var technicalDescriptions = document.querySelectorAll('.technical-description');
    technicalDescriptions.forEach(function (description) {
      var variantValue = description.getAttribute('data-varaint');
      if (variantValue === selectedValue) {
        description.classList.add('custom-active');
        description.classList.remove('custom-hide');
      } else {
        description.classList.remove('custom-active');
        description.classList.add('custom-hide');
      }
    });
  }
});

/* Start: Customization for the "Ducati Ride" Landing Page */

/* This script customizes the behavior of the carousel on the following pages:
   1. Ducati Ride: /pages/ducati-ride
   2. Ducati Ride 2: /pages/ducati-ride2
   3. Design Page: /pages/design
*/

/* Check if the current page URL matches one of the target pages */
if (window.location.pathname === '/pages/ducati-ride' || 
    window.location.pathname === '/pages/ducati-ride2' || 
    window.location.pathname === '/pages/design') {

  /* Select all buttons with specific classes inside the carousel header */
  var elements = document.querySelectorAll(".carousel_head_parent .btn.btn--underline");

  /* Define a function to toggle the carousel content */
  var myFunction = function () {
    if (this.innerText !== 'CLOSE') {
      /* If button text is not 'CLOSE', expand the corresponding carousel */
      var id = this.closest('.shopify-section').nextSibling.id; // Find the ID of the next carousel section
      document.querySelectorAll('.carousel_data').forEach(function (el) {
        el.style.height = 0; // Collapse all carousel sections
      });
      elements.forEach(function (el) {
        el.innerText = 'FIND OUT MORE'; // Reset all buttons to default text
      });
      document.querySelector('#' + id + ' .carousel_data').style.height = 'auto'; // Expand the target carousel
      this.innerText = 'CLOSE'; // Update button text to 'CLOSE'
    } else {
      /* If button text is 'CLOSE', collapse the corresponding carousel */
      var id = this.closest('.shopify-section').nextSibling.id; // Find the ID of the next carousel section
      document.querySelector('#' + id + ' .carousel_data').style.height = 0; // Collapse the target carousel
      this.innerText = 'FIND OUT MORE'; // Reset button text to default
    }
  };

  /* Add event listeners to all buttons to trigger the toggle function */
  for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', myFunction, false);
  }
}

/* End: Customization for the "Ducati Ride" Landing Page */



window.addEventListener("message", function (event) {
  try {
    if (event && event.origin === "https://carrera.jebbit.com" && event.data && event.data.action === "updateIframeHeight" && event.data.jebbitIframeHeight) {
      let iframe = document.querySelector(".jebbit-iframe");
      let newHeight = event.data.jebbitIframeHeight;
      let currentHeight = iframe.clientHeight;
      iframe.style.height = newHeight + "px";
      if (newHeight < currentHeight && (currentHeight - newHeight > 300 || currentHeight > 1300)) {
        let iframeTop = iframe.getBoundingClientRect().top;
        let bodyTop = document.body.getBoundingClientRect().top;
        window.scrollTo({ top: iframeTop - bodyTop, behavior: "smooth" });
      }
    }
  } catch (error) {
    return;
  }
});


/* Start: Chat Icon and Accessibility Button Positioning */

/* Variables for the accessibility button and chat container */
var userway_buttons_wrapper; // Accessibility button wrapper
var gorgias_chat_container;  // Chat container
var chat_button;             // Chat button

/* Debounce function to improve scroll performance */
function debouncee(method, delay) {
  clearTimeout(method._tId); // Clear previous timeout
  method._tId = setTimeout(function () {
    method(); // Execute after delay
  }, delay);
}

/* Adjust button positions based on scroll */
function handleScrolll(ev) {
  // Fetch accessibility button wrapper if not already set
  if (!userway_buttons_wrapper || userway_buttons_wrapper.length == 0) {
    userway_buttons_wrapper = document.querySelectorAll('.userway_buttons_wrapper');
  }

  // Fetch chat container and button if not already set
  if (!gorgias_chat_container) {
    gorgias_chat_container = document.getElementById('gorgias-chat-container');
  }
  if (gorgias_chat_container) {
    chat_button = gorgias_chat_container.querySelector('#chat-button');
  }

  // If scrolled near the bottom, move buttons higher
  if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 20) {
    if (userway_buttons_wrapper && userway_buttons_wrapper[0]) {
      userway_buttons_wrapper[0].style.bottom = "40%";
    }
    if (chat_button) {
      chat_button.style.setProperty("bottom", "38%", "important");
    }
  } else {
    // Reset buttons to default position
    if (userway_buttons_wrapper && userway_buttons_wrapper[0]) {
      userway_buttons_wrapper[0].style.bottom = "75px";
    }
    if (chat_button) {
      chat_button.style.setProperty("bottom", "75px", "important");
    }
  }
}

/* Attach scroll handler with debounce */
window.onscroll = function () {
  debouncee(handleScrolll, 300);
}

/* End: Chat Icon and Accessibility Button Positioning */